import {
  GET_FILTERED_TIME_ENTRIES,
  GET_PROJECTS,
  GET_RATES_BY_PROJECT_LEAD,
  GET_KEY_DATES_BY_PROJECT_SF_ID,
  GET_EXPENSES_BY_PROJECT_IDS,
  GET_WIP_SUMMARY_REPORT_DOC,
  GET_WIP_DETAILED_REPORT_DOC,
  GET_WIP_REPORTS_BY_PROJECT_IDS,
  GET_PROJECT_INVOICES,
  UPDATE_PROJECT_INVOICE,
  EXPORT_INVOICE_DATA,
  GET_PROJECT_OVERVIEW,
} from './query'

export const getProjects = async client => {
  const response = await client.query({
    query: GET_PROJECTS,
  })

  const projects = response.data.getProjects
  return projects
}

export const getTimeEntriesByProjectLeader = async client => {
  const response = await client.query({
    query: GET_FILTERED_TIME_ENTRIES,
  })
  const timeEntriesByProjectLead = response.data.getTimeEntriesByProjectLeader
  return timeEntriesByProjectLead
}

export const getRatesByProjectLead = async (client, projectLeadId, selectedDelegateId) => {
  const response = await client.query({
    query: GET_RATES_BY_PROJECT_LEAD,
    variables: { projectLeadId, selectedDelegateId },
  })

  return response.data.getRatesByProjectLead
}

export const getKeyDatesByProjectSFId = async (client, projectSFId) => {
  const response = await client.query({
    query: GET_KEY_DATES_BY_PROJECT_SF_ID,
    variables: { projectSFId },
  })

  return response.data.getKeyDatesByProjectSFId
}

export const getExpensesByProjectIds = async (client, projectIds) => {
  const response = await client.query({
    query: GET_EXPENSES_BY_PROJECT_IDS,
    variables: { projectIds },
  })

  return response.data.getExpensesByProjectIds
}

export const getWipSummaryReportDoc = async (client, project, wipData, person) => {
  const response = await client.query({
    query: GET_WIP_SUMMARY_REPORT_DOC,
    variables: { project, wipData, person },
  })

  return response.data.getWipSummaryReportDoc
}

export const getWipDetailedReportDoc = async (
  client,
  project,
  wipData,
  keyDates,
  oration,
  budgetTrend,
  actualsToDate,
  budgetMonths,
  pacing,
  invoiceTotals,
  person,
) => {
  const response = await client.query({
    query: GET_WIP_DETAILED_REPORT_DOC,
    variables: {
      project,
      wipData,
      keyDates,
      oration,
      budgetTrend,
      actualsToDate,
      budgetMonths,
      pacing,
      invoiceTotals,
      person,
    },
  })

  return response.data.getWipDetailedReportDoc
}

export const getWipReportsByProjectIds = async (client, projectIds, months) => {
  const response = await client.query({
    query: GET_WIP_REPORTS_BY_PROJECT_IDS,
    variables: { projectIds, months },
  })

  return response.data.getWipReportsByProjectIds
}

export const getProjectInvoices = async (client, projectId) => {
  const response = await client.query({
    query: GET_PROJECT_INVOICES,
    variables: { projectId },
  })

  return response.data.getProjectInvoices
}

const example = {
  invoiceDiscount: {
    type: 'fixed',
    value: 500,
  },
}

export const updateProjectInvoice = async ({ client, invoiceId, invoiceData }) => {
  const response = await client.mutate({
    mutation: UPDATE_PROJECT_INVOICE,
    variables: { invoiceId, invoiceData },
  })

  return response.data.updateProjectInvoice
}

export const exportInvoiceData = async ({ client, invoiceData }) => {
  const response = await client.mutate({
    mutation: EXPORT_INVOICE_DATA,
    variables: { invoiceData },
  })

  return response.data.exportInvoiceData
}

export const getProjectOverview = async (client, projectId) => {
  const response = await client.query({
    query: GET_PROJECT_OVERVIEW,
    variables: { projectId },
  })
  const raw = response.data.getProjectOverview
  return {
    projectName: raw.project.name,
    projectEndDate: raw.project.endDate,
    currency: raw.project.currency,
    months: raw.months,
    personDetails: raw.personLevel,
  }
}
